import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from './ui/button';
import { Eraser } from 'lucide-react';

const SignaturePad = forwardRef(({ onSave, label = "Signature" }, ref) => {
  const sigCanvas = useRef(null);

  const clear = () => {
    sigCanvas.current?.clear();
  };

  const save = () => {
    if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
      return null;
    }
    const dataURL = sigCanvas.current.toDataURL('image/png');
    if (onSave) {
      onSave(dataURL);
    }
    return dataURL;
  };

  const isEmpty = () => {
    return !sigCanvas.current || sigCanvas.current.isEmpty();
  };

  // Expose methods to parent via ref
  useImperativeHandle(ref, () => ({
    save,
    clear,
    isEmpty
  }), []); // Empty deps array - these methods don't change

  return (
    <div className="space-y-2">
      {label && <label className="text-sm font-medium text-slate-700">{label}</label>}
      <div className="bg-slate-50 border-2 border-dashed border-slate-300 rounded-2xl h-40 flex items-center justify-center cursor-crosshair relative overflow-hidden">
        <SignatureCanvas
          ref={sigCanvas}
          canvasProps={{
            className: 'w-full h-full',
            style: { width: '100%', height: '100%' }
          }}
          backgroundColor="rgb(248, 250, 252)"
        />
      </div>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={clear}
          data-testid="signature-clear-button"
          className="rounded-xl"
        >
          <Eraser className="w-4 h-4 mr-2" />
          Effacer
        </Button>
      </div>
    </div>
  );
});

SignaturePad.displayName = 'SignaturePad';

export { SignaturePad };
export default SignaturePad;
